import { render, staticRenderFns } from "./CorsForm.vue?vue&type=template&id=7fb12d4c&"
import script from "./CorsForm.vue?vue&type=script&lang=js&"
export * from "./CorsForm.vue?vue&type=script&lang=js&"
import style0 from "./CorsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports